import React from 'react';
import { Checkbox } from '@repo/common';

const HeaderItem = ({
  label,
  minWidth,
  maxWidth,
  isGrow = false,
  align = 'center',
}) => {
  const alignmentClass = align === 'left' ? 'items-start' : 'items-center';

  return (
    <div
      className={`flex flex-col justify-center ${alignmentClass} px-2 py-3 relative z-10 text-text-primary w-full ${
        isGrow ? 'flex-1' : 'flex-shrink-0'
      }`}
      style={!isGrow ? { minWidth: minWidth, maxWidth: maxWidth } : {}}
    >
      <span className='typo-b13Strong'>{label}</span>
    </div>
  );
};

const WorkshopDetailListHeader = ({ isAllSelected, onSelectAll, type }) => {
  return (
    <div className='flex w-full items-start pb-4'>
      <div className='flex w-full items-start border-b-[1.6px] border-grayscale-gray01 pr-8'>
        <div className='flex px-2 py-3 items-center gap-2.5'>
          <Checkbox
            checked={isAllSelected}
            onChange={() => onSelectAll(!isAllSelected)}
          />
        </div>
        <div
          className={`flex px-2 py-3 items-center ${
            type === 'waitlisted' ? 'w-[66px]' : 'w-[40px]'
          }`}
        >
          {type === 'confirmed' && <div className='w-6 h-6' />}
        </div>
        <>
          <HeaderItem
            minWidth='200px'
            maxWidth={`${
              type === 'confirmed' || type === 'canceled' || type === 'blocked'
                ? '380px'
                : ''
            }`}
            label='User name'
            align='left'
            isGrow
          />
          <HeaderItem
            minWidth='200px'
            maxWidth={`${
              type === 'canceled' || type === 'blocked' ? '260px' : '380px'
            }`}
            isGrow={type !== 'canceled' && type !== 'blocked'}
            label='Email'
          />
          {type === 'confirmed' && (
            <>
              <HeaderItem
                minWidth='120px'
                maxWidth='240px'
                label='Confirmation date'
              />
              <HeaderItem minWidth='120px' maxWidth='240px' label='Status' />
            </>
          )}

          {type === 'waitlisted' && (
            <>
              <HeaderItem
                minWidth='120px'
                maxWidth='260px'
                label='Waitlisted date'
              />
            </>
          )}

          {type === 'canceled' && (
            <>
              <HeaderItem
                minWidth='120px'
                maxWidth='180px'
                label='Cancellation Date'
              />
              <HeaderItem
                minWidth='120px'
                maxWidth='220px'
                label='Cancellation Reason'
              />
              <HeaderItem
                minWidth='120px'
                maxWidth='220px'
                label='Refund status'
              />
            </>
          )}

          {type === 'blocked' && (
            <>
              <HeaderItem
                minWidth='120px'
                maxWidth='120px'
                label='Blocked at'
              />
              <HeaderItem
                minWidth='120px'
                maxWidth='120px'
                label='Unblock Date'
              />
              <HeaderItem
                minWidth='120px'
                maxWidth='200px'
                label='Block Reason'
              />
              <HeaderItem
                minWidth='120px'
                maxWidth='120px'
                label='Block status'
              />
            </>
          )}

          <HeaderItem
            minWidth={`${
              type === 'confirmed'
                ? '160px'
                : type === 'canceled' || type === 'blocked'
                ? '120px'
                : '180px'
            }`}
            maxWidth={`${
              type === 'confirmed'
                ? '160px'
                : type === 'canceled' || type === 'blocked'
                ? '120px'
                : '180px'
            }`}
          />
          <HeaderItem minWidth='40px' maxWidth='40px' />
        </>
      </div>
    </div>
  );
};

export default WorkshopDetailListHeader;
